export default {
      id: "LWS-2px-usage",
      viewBox: "0 0 60 2",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-2px",
      toString: function () {
        return this.url;
      }
    }